import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = new FormData()

  data.set('username', username)
  data.set('password', password)

  return request({
    url: '/authenticate',
    method: 'post',
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
    data
  })
}

export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/api/users/me',
    method: 'get'
  })
}

export function getSystemVersion() {
  return request({
    url: '/actuator/info',
    method: 'get'
  })
}
